import { Box, SystemStyleObject } from "@chakra-ui/react";
import { assets } from "../../../assets";
import { SocialButton } from "./SocialButton";

type SocialButtonsGroupProps = {
  sx?: SystemStyleObject;
  onAppleClick?: () => void;
  onFacebookClick?: () => void;
  onGoogleClick?: () => void;
  type?: "login" | "signup";
};

const SocialButtonsGroup = ({
  onAppleClick,
  onFacebookClick,
  onGoogleClick,
  sx,
  type,
}: SocialButtonsGroupProps) => {
  return (
    <Box display={"flex"} justifyContent={"center"} sx={sx} gap={".5rem"}>
      {onAppleClick && (
        <SocialButton
          type={type}
          src={assets.icons.appleLogo}
          onClick={onAppleClick}
        />
      )}
      {onFacebookClick && (
        <SocialButton
          src={assets.icons.facebookLogo}
          onClick={onFacebookClick}
          type={type}
        />
      )}
      {onGoogleClick && (
        <SocialButton
          type={type}
          src={assets.icons.googleLogo}
          onClick={onGoogleClick}
        />
      )}
    </Box>
  );
};

export default SocialButtonsGroup;
